import { render, staticRenderFns } from "./ManageDeckMetadataModal.vue?vue&type=template&id=f07264ae&scoped=true"
import script from "./ManageDeckMetadataModal.vue?vue&type=script&lang=js"
export * from "./ManageDeckMetadataModal.vue?vue&type=script&lang=js"
import style0 from "./ManageDeckMetadataModal.vue?vue&type=style&index=0&id=f07264ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07264ae",
  null
  
)

export default component.exports